import React from 'react'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'
import { getFullUrl, changeUrlLanguage } from '../../utils/navigation'

const SEO = ({
  category = '',
  description = '',
  distinctLangs = [],
  image = '',
  locale = '',
  noIndex = false,
  tags = [],
  title = '',
  url = '',
}) => {
  const env = process.env.GATSBY_ACTIVE_ENV
  const { site } = useStaticQuery(graphql`
    query SEO {
      site {
        siteMetadata {
          defaultTitle: title
        }
      }
    }
  `)

  const seo = {
    image: image || getFullUrl('/assets/logo.png'),
    title: title || site.siteMetadata.defaultTitle,
    url: getFullUrl(url),
  }

  const renderDistinctLangs = () => {
    return distinctLangs.map(lang => (
      <link
        key={lang}
        rel="alternate"
        hrefLang={lang === 'pt-BR' ? 'x-default' : lang}
        href={changeUrlLanguage(seo.url, locale, lang)}
      />
    ))
  }

  return (
    <Helmet title={seo.title} defer={false}>
      {locale && <html lang={locale} />}
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/docsearch.js@2/dist/cdn/docsearch.min.css"
      />
      {noIndex ||
        (env !== 'production' && (
          <meta name="robots" content="noindex, nofollow" />
        ))}
      <link rel="icon" href={getFullUrl('/assets/favicon.ico')} />
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta property="og:type" content="article" />
      <meta property="og:site_name" content="Hotmart Developers" />
      <meta
        property="article:publisher"
        content="https://www.facebook.com/hotmartofficial"
      />
      <meta property="article:author" content="hotmartofficial" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@hotmart" />
      <meta name="twitter:creator" content="@hotmart" />

      {renderDistinctLangs()}

      {description && [
        <meta key="desc" name="description" content={description} />,
        <meta key="desc-og" property="og:description" content={description} />,
        <meta key="desc-tw" name="twitter:description" content={description} />,
      ]}

      {seo.title && [
        <meta key="title" property="og:title" content={seo.title} />,
        <meta key="title-tw" name="twitter:title" content={seo.title} />,
      ]}

      {url && [
        <meta key="url" itemProp="url" content={seo.url} />,
        <meta key="url-og" property="og:url" content={seo.url} />,
      ]}
      {tags && tags.length && <meta name="keywords" content={tags.join(',')} />}

      {locale && [
        <meta key="lcl" property="og:locale" content={locale} />,
        <meta key="lcl-alg" name="docsearch:language" content={locale} />,
      ]}

      {seo.image && [
        <meta key="img" itemProp="image" content={seo.image} />,
        <meta key="img-og" property="og:image" content={seo.image} />,
        <meta
          key="img-ogs"
          property="og:image:secure_url"
          content={seo.image}
        />,
        <meta key="img-ogw" property="og:image:width" content="200" />,
        <meta key="img-ogh" property="og:image:height" content="200" />,
        <meta key="img-tw" name="twitter:image" content={seo.image} />,
      ]}

      {category && <meta property="article:section" content={category} />}
    </Helmet>
  )
}

export default SEO
